import { useTranslation } from "react-i18next";
import {
  oldDisplayForResult,
  searchResultCallbackProps,
  SearchResultProps,
} from "common-client/utils/search";
import { OmniboxSearchResult } from "../../generated/graphql";
import Loading from "../Common/Icons/Loading";
import { Body } from "../Common/Typography";
import { Status } from ".";
import {
  CenterContentContainer,
  Dropdown,
  Option,
} from "./__styles__/Dropdown";

export const ResultsDropdown = ({
  results,
  handleResultClick,
  status,
  onResultSelect,
}: {
  results: Array<OmniboxSearchResult>;
  handleResultClick: (searchResult: SearchResultProps) => void;
  status: Status;
  onResultSelect: () => void;
}) => {
  const { t } = useTranslation();

  const handleResult = (result: OmniboxSearchResult) => {
    onResultSelect();
    handleResultClick(searchResultCallbackProps(result));
  };

  return (
    <Dropdown data-testid="search-dropdown">
      {status === "search_complete" && !results.length && (
        <CenterContentContainer>
          <Body size="default" type="regular">
            {t("search-no-results")}
          </Body>
        </CenterContentContainer>
      )}
      {status === "loading" && (
        <CenterContentContainer data-testid="loading" tabIndex={0}>
          <Loading size="small" />
        </CenterContentContainer>
      )}
      {results.slice(0, 5).map((result, index) => {
        const display = oldDisplayForResult(result);
        return (
          <Option
            key={index}
            tabIndex={0}
            onClick={() => handleResult(result)}
            onKeyDown={e => {
              if (e.key === "Enter") {
                handleResult(result);
              }
            }}
          >
            <Body size="large" type="emphasis">
              {display.title}
            </Body>
            <Body size="large" type="regular">
              {display.description}
            </Body>
          </Option>
        );
      })}
    </Dropdown>
  );
};
